<template>
 <div class="header">
        <img src="../../admin/assets/images/logo2.png" class="header-img">
        <el-divider direction="vertical"></el-divider>
        <p>认证考试</p>
    </div>
</template>

<script>
export default {
  name: 'examheader',
  data() {
    return {

    }
  },
}
</script>
<style lang="less" scoped>
.header{
  height: 50px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  padding-left: 130px;
  padding-bottom: 20px;
  padding-top: 20px;
}
.header p{
  font-size: 24px;
  color:#6E9FE1;
  letter-spacing: 2px;
  margin-left: 5px;
}
.header-img{
  width: 323px;
  height: 76px;
}
/deep/.el-divider--vertical {
  height: 3em;
}
.el-divider{
  background-color: #6E9FE1;
}
</style>
